import { useAccessibleCard } from '@squiz/xaccel-accessibility';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../css/functional.module.scss';
/**
 * Simple Generic Result Component.
 *
 * @param {string} titleHtml Title of the Best Bet.
 * @param {string} displayUrl Best Bet URL with click-tracker.
 * @param {string} linkUrl Plain URL of the Best Bet (no click-tracker).
 * @param {string} descriptionHtml Description of the Best Bet.
 * @param {string} messageHtml Main content of the Best Bet.
 * @param {string} userDisplayMode Inherited from the parent, defines styles.
 *
 * @returns {JSX.Element}
 * @constructor
 */
function BestBetResult({ titleHtml, displayUrl, linkUrl, descriptionHtml, messageHtml, userDisplayMode }) {
    const rootClass = 'funnelback-instant-search-best-bet';
    let content = '';
    if (descriptionHtml && descriptionHtml.length > 0) {
        content = descriptionHtml;
    } else if (messageHtml && messageHtml.length > 0) {
        content = messageHtml;
    }

    const { cardRef, linkRef } = useAccessibleCard();

    return (
        <article
            className={`${rootClass} ${
                userDisplayMode === 'grid'
                    ? `${styles.gridViewCard} funnelback-instant-search-grid-view__card`
                    : `${styles.listViewCard} funnelback-instant-search-list-view__card`
            }`}
            ref={cardRef}
        >
            <div
                className={
                    userDisplayMode === 'grid'
                        ? `${styles.gridViewCardInnerWrapper} funnelback-instant-search-grid-view__card--inner-wrapper`
                        : `${styles.listViewCardMain} funnelback-instant-search-list-view__card--main`
                }
            >
                <div className={`${rootClass}__content`}>
                    {titleHtml && (
                        <div className={`${rootClass}__header`}>
                            {linkUrl ? (
                                <>
                                    <a href={linkUrl} title={displayUrl} className={`${rootClass}__title-link`} ref={linkRef}>
                                        <h3 className={`${rootClass}__title`}>{titleHtml}</h3>
                                    </a>
                                    <cite className={`${rootClass}__subtitle ${rootClass}__subtitle--highlight`}>{displayUrl}</cite>
                                </>
                            ) : (
                                <h3 className={`${rootClass}__title`}>{titleHtml}</h3>
                            )}
                        </div>
                    )}

                    {content && (
                        <div className={`${rootClass}__body`}>
                            <div className={`${rootClass}__summary`}>{content}</div>
                        </div>
                    )}
                </div>
            </div>
        </article>
    );
}
const { string, shape } = PropTypes;

BestBetResult.propTypes = shape({
    titleHtml: string,
    displayUrl: string,
    linkUrl: string,
    descriptionHtml: string,
    messageHtml: string,
    userDisplayMode: string,
}).isRequired;

export default BestBetResult;
